<script setup>
import VisitorTable from '@/views/care-visit/visitor/VisitorTable.vue'
import VisitorRegistrationDialog from '@/views/care-visit/VisitorRegistrationDialog.vue'
import CustomerTable from '@/views/care-visit/customer/CustomerTable.vue'
import VisitorPassDialog from '@/views/care-visit/VisitorPassDialog.vue'

definePage({
  meta: {
    name: "Customer Management",
    subject: "care_visit.menu",
    action: "customer",
  },
})

const refTable = ref()

const episodeData = ref(null)

const showGenerateVisitorPassDialog = ref(false)

watch(() => showGenerateVisitorPassDialog.value, value => {
  if (value === false) {
    episodeData.value = null
  }
})


const showVisitorPassDialog = ref(false)
const visitorPassData = ref(null)

watch(() => showVisitorPassDialog.value, value => {
  if (value === false) {
    episodeData.value = null
    visitorPassData.value = null
  }
})
</script>

<template>
  <VRow>
    <VCol cols="12">
      <CustomerTable
        ref="refTable"
        @generate-visitor-pass="item => {
          episodeData = item
          showGenerateVisitorPassDialog = true
        }"
        @visitor-pass="(episode, visitorPass) => {
          episodeData = episode
          visitorPassData = visitorPass
          showVisitorPassDialog = true
        }"
      />
    </VCol>
  </VRow>

  <VisitorRegistrationDialog 
    v-model:isDialogOpen="showGenerateVisitorPassDialog"
    :episode-data="episodeData"
    @saved="() => refTable.fetchEpisodes()"
  /> 
 
  <VisitorPassDialog
    v-model:isDialogOpen="showVisitorPassDialog"
    :episode-data="episodeData"
    :visitor-pass-data="visitorPassData"
  />
</template>
